<template>
  <div class="page-wrap">

    <div class="panel-card">

      <!-- Header -->
      <div class="panel-header">
        <div class="panel-header-left">
          <div class="panel-icon"><i class="la la-stream"></i></div>
          <div>
            <div class="panel-title">
              Archival Expiration
              <span class="count-badge" v-if="appoinments.length > 0">{{ appoinments.length }}</span>
            </div>
            <div class="panel-sub">Near-expiry archived enrollments</div>
          </div>
        </div>
        <div class="panel-header-right" v-if="appoinments.length > 0 && !getLoadingData">
          <download-excel class="btn-export" :data="excelreports" :header="header" name="archival-expiration-report.xls"
            :fields="json_fields">
            <i class="fa fa-download"></i> Export
          </download-excel>
        </div>
      </div>

      <!-- Search -->
      <div class="search-section">
        <adv-search @search="advSearch" :is_date_range="false" :is_service="true" :is_admin_sp_location="true"
          :is_admin_sp="true" :is_status="false" :is_location="false" :is_archival="true" :is_company1="true" />
      </div>

      <!-- Loading -->
      <div class="state-box" v-if="getLoadingData">
        <i class="fa fa-spinner fa-spin"></i> Loading…
      </div>

      <!-- Empty -->
      <div class="state-box" v-else-if="!getLoadingData && appoinments.length === 0 && searched">
        <i class="la la-stream"></i> No archived enrollments found
      </div>

      <!-- Table -->
      <div class="table-wrap" v-else-if="appoinments.length > 0 && !getLoadingData">
        <table class="arch-table">
          <thead>
            <tr>
              <th style="width:110px;">Enroll Date</th>
              <th style="width:80px;">Enr #</th>
              <th style="min-width:130px;">Applicant</th>
              <th style="width:180px;">TCN</th>
              <th style="min-width:120px;">Company</th>
              <th style="min-width:160px;">Service / Location</th>
              <th style="width:100px;">Archival</th>
              <th style="width:110px;">Expires On</th>
              <th style="width:46px; text-align:right; padding:10px 6px;">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in paginatedAppointments" :key="index">
              <td class="col-mono">{{ item.enroll_date }}</td>
              <td>
                <a class="enr-link" href="javascript:void(0)" @click="openEnrollmentDetail(item.id, index)">
                  {{ item.id }}
                </a>
              </td>
              <td>{{ item.applicant }}</td>
              <td class="col-mono">{{ item.tcn }}</td>
              <td>{{ item.company_name || '—' }}</td>
              <td>
                <span class="service-name">{{ item.service_name }}<span v-if="item.is_additional">, {{
                  item.is_additional }}</span></span>
                <span class="location-name" v-if="item.originating_location_name">{{ item.originating_location_name
                  }}</span>
              </td>
              <td>{{ item.archival_name || '—' }}</td>
              <td>
                <span :class="['expiry-badge', isExpired(item.archival_expiry_date) ? 'expired' : 'active']">
                  <i :class="isExpired(item.archival_expiry_date) ? 'fa fa-exclamation-circle' : 'fa fa-clock'"></i>
                  {{ dateFormat(item.archival_expiry_date) }}
                </span>
              </td>
              <td style="text-align:right; overflow:visible; padding:10px 6px;" @click.stop
                v-if="item.enrollment_id != ''">
                <div class="action-wrap" :class="{ open: openIndex === index }"
                  @click.stop="toggleDropdown(index, $event)">
                  <div class="action-btn">•••</div>
                  <div class="action-menu" :style="openIndex === index ? menuStyle : null">
                    <div class="menu-item teal" @click.stop="renewArchival(item)">
                      <i class="fa fa-redo"></i> Renew Archival
                    </div>
                    <div class="menu-item divider"></div>
                    <div class="menu-item danger" @click.stop="promptRemove(item)">
                      <i class="fa fa-trash"></i> Remove Archive
                    </div>
                  </div>
                </div>
              </td>
              <td v-else></td>
            </tr>
          </tbody>
        </table>

        <!-- Pagination -->
        <div class="pagination-bar" v-if="totalPages > 1">
          <div class="page-info">
            Showing {{ pageStart }}–{{ pageEnd }} of {{ appoinments.length }} records
          </div>
          <div class="page-controls">
            <button class="page-btn" :disabled="currentPage === 1" @click="currentPage = 1">
              <i class="fa fa-angle-double-left"></i>
            </button>
            <button class="page-btn" :disabled="currentPage === 1" @click="currentPage--">
              <i class="fa fa-angle-left"></i>
            </button>
            <button v-for="p in visiblePages" :key="p" class="page-btn" :class="{ active: p === currentPage }"
              @click="currentPage = p">{{ p }}</button>
            <button class="page-btn" :disabled="currentPage === totalPages" @click="currentPage++">
              <i class="fa fa-angle-right"></i>
            </button>
            <button class="page-btn" :disabled="currentPage === totalPages" @click="currentPage = totalPages">
              <i class="fa fa-angle-double-right"></i>
            </button>
          </div>
          <div class="page-size">
            <select v-model.number="pageSize" @change="currentPage = 1" class="size-select">
              <option :value="15">15 / page</option>
              <option :value="25">25 / page</option>
              <option :value="50">50 / page</option>
            </select>
          </div>
        </div>

      </div>

    </div>

    <!-- Remove Archive confirm modal -->
    <div class="del-overlay" v-if="delModal.show" @click.self="delModal.show = false">
      <div class="del-card">
        <div class="del-head">
          <i class="fa fa-trash"></i> Remove Archive
        </div>
        <div class="del-body">
          <p>Remove <strong>Enrollment #{{ delModal.id }}</strong></p>
          <p class="del-sub">TCN: {{ delModal.tcn }}</p>
          <p class="del-warn">This will remove the enrollment from archive. This action cannot be undone.</p>
        </div>
        <div class="del-foot">
          <button class="btn-del-cancel" @click="delModal.show = false"><i class="fa fa-times"></i> Cancel</button>
          <button class="btn-del-confirm" @click="confirmRemove()"><i class="fa fa-trash"></i> Remove</button>
        </div>
      </div>
    </div>

    <!-- Enrollment detail modal -->
    <enrollmentDetailModal :key="key" v-if="enrollmentDetailModalShow" v-on:closemodal="closeEnrollmentModal"
      :loading-data="loadingData" :has-data="hasData" :show-modal="enrollmentDetailModalShow"
      :enrollment-data="enrollmentData" :index-num="currentIndex" />

  </div>
</template>

<script>
import moment from "moment";
import {
  FETCH_EXPIRY_ARCHIVAL_APPOINTMENT,
  FETCH_CLIENTS,
  FETCH_SERVICES,
  FETCH_ENROLLMENT,
  ENROLLMENT_LOGS,
  REMOVE_ARCHIVE
} from "@/core/services/store/actions.type";
import { SET_BREADCRUMB } from "@/core/services/store/mutations.type";
import { mapGetters } from "vuex";
import enrollmentDetailModal from "@/components/frontend/modal/enrollmentdetail";
import AdvSearch from "@/includes/search/AdvSearch";
import JsonExcel from "vue-json-excel";

export default {
  components: {
    AdvSearch,
    enrollmentDetailModal,
    downloadExcel: JsonExcel
  },
  computed: {
    ...mapGetters(["currentUser", "getClients", "getServices"]),
    totalPages() {
      return Math.ceil(this.appoinments.length / this.pageSize);
    },
    pageStart() {
      return this.appoinments.length === 0 ? 0 : (this.currentPage - 1) * this.pageSize + 1;
    },
    pageEnd() {
      return Math.min(this.currentPage * this.pageSize, this.appoinments.length);
    },
    paginatedAppointments() {
      const start = (this.currentPage - 1) * this.pageSize;
      return this.appoinments.slice(start, start + this.pageSize);
    },
    visiblePages() {
      const pages = [];
      for (let i = Math.max(1, this.currentPage - 2); i <= Math.min(this.totalPages, this.currentPage + 2); i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  props: {
    AppType: { type: Boolean, default: true },
    DashType: { type: String, default: "appointment_list" }
  },
  data() {
    return {
      enrollmentData: {},
      enrollmentDetailModalShow: false,
      json_fields: {
        "Enroll Date": { field: "enroll_date", callback: v => this.dateFormat(v) },
        "Applicant Name": "applicant",
        TCN: "tcn",
        Location: "client_name",
        Company: "company_name",
        Service: "service_name",
        Archival: "archival_name",
        "Expires On": { field: "archival_expiry_date", callback: v => this.dateFormat(v) }
      },
      getLoadingData: false,
      header: [],
      excelreports: [],
      openIndex: null,
      menuStyle: null,
      currentPage: 1,
      pageSize: 15,
      delModal: { show: false, id: null, tcn: null },
      columns: [],
      breadCrumbs: [
        { id: 1, title: "Dashboard", route: "client.dashboard" },
        { id: 2, title: "Archival Expiration", route: "" }
      ],
      search: { service: "all", location: "all", status: "all", payment_status: "all", no_of_days: 99999, sp_location: null },
      appoinments: [],
      searched: false,
      currentIndex: -1,
      loadingData: false,
      hasData: false,
      key: 0
    };
  },
  mounted() {
    if (window.localStorage.getItem("appoitmentsearch") != null) {
      let s = JSON.parse(window.localStorage.getItem("appoitmentsearch"));
      this.search.service = s.service;
      this.search.status = s.status;
      this.search.payment_status = s.payment_status;
      this.search.location = s.service_outlet ? s.service_outlet : "all";
      this.$store.dispatch(FETCH_SERVICES, this.search.location);
    } else {
      this.search.location = this.currentUser.u.is_client ? "self" : "all";
      this.$store.dispatch(FETCH_SERVICES, this.search.location);
    }
    this.$store.dispatch(FETCH_CLIENTS);
    if (this.AppType) this.$store.commit(SET_BREADCRUMB, this.breadCrumbs);
    document.addEventListener("click", this.closeDropdown);
    window.addEventListener("scroll", this.closeDropdown, true);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.closeDropdown);
    window.removeEventListener("scroll", this.closeDropdown, true);
  },
  methods: {
    isExpired(date) {
      return date && new Date(date) < new Date();
    },
    dateFormat(date) {
      if (!date) return "—";
      return moment(date).format("MM/DD/YYYY");
    },
    toggleDropdown(index, event) {
      if (this.openIndex === index) {
        this.openIndex = null;
        this.menuStyle = null;
        return;
      }
      this.openIndex = index;
      this.$nextTick(() => {
        const rect = event.currentTarget.getBoundingClientRect();
        const menuH = 90;
        const rightOffset = window.innerWidth - rect.right;
        if (window.innerHeight - rect.bottom < menuH + 8) {
          this.menuStyle = { position: 'fixed', bottom: (window.innerHeight - rect.top + 4) + 'px', top: 'auto', right: rightOffset + 'px' };
        } else {
          this.menuStyle = { position: 'fixed', top: (rect.bottom + 4) + 'px', bottom: 'auto', right: rightOffset + 'px' };
        }
      });
    },
    closeDropdown() {
      this.openIndex = null;
      this.menuStyle = null;
    },
    renewArchival(item) {
      this.closeDropdown();
      this.$router.push({
        name: "client.changearchive.enrollment",
        params: { enroll_id: item.enrollment_id, tcn: item.tcn, onsite: false, client_slug: item.client_slug }
      });
    },
    promptRemove(item) {
      this.closeDropdown();
      this.delModal = { show: true, id: item.id, tcn: item.tcn };
    },
    confirmRemove() {
      this.$store.dispatch(REMOVE_ARCHIVE, { enrollment_id: this.delModal.id })
        .then(res => {
          if (res.code == 200) {
            this.$toastr.s(res.msg);
            this.delModal.show = false;
            this.appData();
          }
        })
        .catch(err => { this.$toastr.e(err.error); this.delModal.show = false; });
    },
    advSearch(value) {
      if (this.search.no_of_days > 0) {
        let { header, search } = value;
        this.header = header;
        this.search = { ...search };
        this.appData();
      } else {
        this.$toastr.e("No of days should be greater than zero");
      }
    },
    closeEnrollmentModal() {
      this.enrollmentDetailModalShow = false;
    },
    openEnrollmentDetail(enrollmentId, index) {
      this.currentIndex = index;
      this.enrollmentDetailModalShow = true;
      this.loadingData = true;
      this.$store.dispatch(ENROLLMENT_LOGS, { enrollment_id: enrollmentId });
      this.$store.dispatch(FETCH_ENROLLMENT, { enrollment_id: enrollmentId })
        .then(res => {
          this.enrollmentData = res.data;
          this.loadingData = false;
          this.hasData = res.hasData;
          this.key += 1;
        })
        .catch(() => { this.loadingData = false; });
    },
    appData() {
      this.appoinments = [];
      this.getLoadingData = true;
      this.searched = true;
      const data_ = {
        service_outlet: this.search?.sp_location,
        ...this.search,
        type: this.currentUser.u.is_client ? "c" : "sp"
      };
      this.$store.dispatch(FETCH_EXPIRY_ARCHIVAL_APPOINTMENT, data_)
        .then(res => {
          this.excelreports = [...res.data];
          this.appoinments = res.data;
          this.currentPage = 1;
          this.getLoadingData = false;
        })
        .catch(err => {
          this.getLoadingData = false;
          this.$toastr.e(err.error || "Failed to load data");
        });
    }
  }
};
</script>

<style lang="scss" scoped>
$font: 'Segoe UI', sans-serif;
$blue: #389ad4;
$dark: #0d1b3e;
$border: #dde2ec;
$green: #276749;
$orange: #F58020;

.page-wrap {
  padding: 24px;
  font-family: $font;
}

/* ── Panel card ── */
.panel-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 16px rgba(13, 27, 62, 0.08);
  overflow: clip;
}

.panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px 18px;
  border-bottom: 1px solid #f0f3fa;
  background: #fafbff;
  flex-wrap: wrap;
  gap: 12px;
}

.panel-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
}

.panel-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, $blue, #2176ae);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.panel-title {
  font-size: 15px;
  font-weight: 700;
  color: $dark;
  display: flex;
  align-items: center;
  gap: 8px;
}

.panel-sub {
  font-size: 12px;
  color: #8a94a6;
  margin-top: 2px;
}

.count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: $blue;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  border-radius: 20px;
  padding: 1px 8px;
  min-width: 24px;
}

.panel-header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.btn-export {
  height: 36px;
  padding: 0 16px;
  border-radius: 8px;
  border: 1.5px solid $green;
  background: transparent;
  color: $green;
  font-size: 13px;
  font-weight: 600;
  font-family: $font;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: #f0faf4;
    color: $green;
    text-decoration: none;
  }
}

/* ── Search section ── */
.search-section {
  padding: 16px 24px;
  border-bottom: 1px solid #f0f3fa;
  background: #fafbff;
}

/* ── State boxes ── */
.state-box {
  text-align: center;
  padding: 56px 24px;
  color: #a0aab8;
  font-size: 13px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  i {
    font-size: 18px;
  }
}

/* ── Table ── */
.table-wrap {
  overflow-x: auto;
}

.arch-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  font-family: $font;
  table-layout: auto;

  thead tr {
    background: #f7f9fc;
    border-bottom: 2px solid #e8ecf5;
  }

  th {
    padding: 10px 14px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #7a8499;
    white-space: nowrap;
    position: sticky;
    top: 0;
    background: #f7f9fc;
    z-index: 1;
  }

  td {
    padding: 11px 14px;
    color: #2d3748;
    border-bottom: 1px solid #f0f3fa;
    vertical-align: middle;
    white-space: nowrap;
  }

  tbody tr:hover {
    background: #fafbff;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }
}

.col-mono {
  font-family: 'Courier New', monospace;
  font-size: 12px;
  font-weight: 600;
}

.col-bold {
  font-weight: 600;
}

.enr-link {
  color: $blue;
  font-weight: 600;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.service-name {
  display: block;
  font-weight: 500;
  color: $dark;
  white-space: normal;
  word-break: break-word;
  min-width: 140px;
}

.location-name {
  display: block;
  font-size: 11px;
  color: #8a94a6;
  margin-top: 1px;
  white-space: normal;
  word-break: break-word;
}

/* ── Expiry badge ── */
.expiry-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 6px;

  &.expired {
    background: #fff0f0;
    color: #c62828;

    i {
      color: #c62828;
    }
  }

  &.active {
    background: #f0faf4;
    color: $green;

    i {
      color: $green;
    }
  }
}

/* ── Action dropdown ── */
.action-wrap {
  position: relative;
  display: inline-block;

  .action-btn {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    background: #f5f7fa;
    border: 1px solid #e2e8f0;
    cursor: pointer;
    font-size: 16px;
    font-weight: 700;
    color: #4a5568;
    letter-spacing: 1px;
    transition: background 0.15s;

    &:hover {
      background: #eef2fb;
      color: #185FA5;
      border-color: #c5d4f0;
    }
  }

  .action-menu {
    display: none;
    position: fixed;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    min-width: 160px;
    box-shadow: 0 8px 24px rgba(13, 27, 62, 0.12);
    z-index: 9999;
    overflow: hidden;

    .menu-item {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 9px 14px;
      font-size: 13px;
      color: #2d3748;
      cursor: pointer;
      transition: background 0.15s;

      i {
        width: 16px;
        font-size: 13px;
      }

      &:hover {
        background: #f8fbff;
      }

      &.teal {
        color: $green;

        i {
          color: $green;
        }

        &:hover {
          background: #f0fdf4;
        }
      }

      &.danger {
        color: #c62828;

        i {
          color: #c62828;
        }

        &:hover {
          background: #fff5f5;
        }
      }

      &.divider {
        border-top: 1px solid #f0f3fa;
        pointer-events: none;
        padding: 0;
        margin: 0;
      }
    }
  }

  &.open .action-menu {
    display: block;
  }
}

/* ── Remove archive modal ── */
.del-overlay {
  position: fixed;
  inset: 0;
  background: rgba(13, 27, 62, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9100;
  backdrop-filter: blur(3px);
  font-family: $font;
}

.del-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 20px 60px rgba(13, 27, 62, 0.2);
  width: 100%;
  max-width: 420px;
  overflow: hidden;
}

.del-head {
  background: #fff0f0;
  color: #c62828;
  padding: 18px 24px;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 10px;
  border-bottom: 1px solid #fdd;
}

.del-body {
  padding: 20px 24px;

  p {
    margin: 0 0 6px;
    font-size: 13px;
    color: $dark;
  }

  .del-sub {
    color: #7a8499;
    font-family: 'Courier New', monospace;
    font-size: 12px;
  }

  .del-warn {
    margin-top: 12px;
    font-size: 12px;
    color: #c05621;
    background: #fffaf0;
    border-radius: 6px;
    padding: 8px 12px;
  }
}

.del-foot {
  display: flex;
  gap: 10px;
  padding: 16px 24px;
  border-top: 1px solid #f0f3fa;

  button {
    flex: 1;
    height: 38px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    font-family: $font;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.15s;
    border: none;
  }

  .btn-del-cancel {
    background: #fff;
    color: #4a5568;
    border: 1.5px solid $border;

    &:hover {
      border-color: $blue;
      color: $blue;
    }
  }

  .btn-del-confirm {
    background: #c62828;
    color: #fff;

    &:hover {
      background: #9b1c1c;
    }
  }
}

/* ── Pagination ── */
.pagination-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 20px;
  border-top: 1px solid #f0f3fa;
  flex-wrap: wrap;
  gap: 10px;
}

.page-info {
  font-size: 12px;
  color: #8a94a6;
}

.page-controls {
  display: flex;
  align-items: center;
  gap: 4px;
}

.page-btn {
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  border-radius: 6px;
  border: 1.5px solid $border;
  background: #fff;
  color: #4a5568;
  font-size: 12px;
  font-family: $font;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  display: inline-flex;
  align-items: center;
  justify-content: center;

  &:hover:not(:disabled) {
    border-color: $blue;
    color: $blue;
    background: #eef7fb;
  }

  &.active {
    background: $blue;
    color: #fff;
    border-color: $blue;
  }

  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
}

.page-size {
  .size-select {
    height: 32px;
    border-radius: 6px;
    border: 1.5px solid $border;
    font-size: 12px;
    font-family: $font;
    color: #4a5568;
    padding: 0 8px;
    outline: none;

    &:focus {
      border-color: $blue;
    }
  }
}
</style>
